<div>
  <app-base-report
    *ngIf="gatData"
    [hasDateRangeFilter]="true"
    [hasCheckboxes]="false"
    [reportName]="'Temporary Transactions Report'"
    [defaultColumns]="properties"
    [columnsDisplayNames]="displayTableColumns"
    [filterFields]="selectFilters"
    [data]="gatData"
    [rowsLength]="totalNumberOfRecords"
    (filterTrigger)="getCurrentPage($event)"
    (paginationChange)="paginate($event)"
    (searchChange)="searchChange($event)"
    [tableLoading]="loading"
    [hasSort]="true"
    (sortTrigger)="sortChange($event)"
    [serviceInstance]="tempTransactionsReport"
  >
  </app-base-report>
</div>

